import React from 'react';
import TypeRegroupement from '../../constants/feuilleSaisie/typeRegroupement';
import type TreeRow from '../../interfaces/feuilleSaisie/treeRow';
import type BaseFeuilleSaisie from '../feuilleSaisies/BaseFeuilleSaisie';
import BaseTypeRegroupement from './BaseTypeRegroupement';

class SectionTypeRegroupement extends BaseTypeRegroupement {
	constructor() {
		super();
		this.code = TypeRegroupement.SECTION;
		this.codeColumnName = 'cha_section';
		this.icon = {
			iconSet: 'Lucide',
			name: 'CircleArrowRight',
		};
		this.libelle = 'Section';
	}

	getLibelle(data: TreeRow, _feuille: BaseFeuilleSaisie): string {
		if (data?.[this.codeColumnName] === 'I') {
			return 'Investissement';
		}

		if (data?.[this.codeColumnName] === 'F') {
			return 'Fonctionnement';
		}

		return '';
	}

	getTabLibelle(data: TreeRow): React.JSX.Element {
		return <>{this.getLibelle(data, null)}</>;
	}
}

export default SectionTypeRegroupement;
